import { Component, Vue } from 'vue-property-decorator';
import Pagination from '@/components/Pagination.vue';

@Component({
  components: {
    pagination: Pagination
  }
})

export default class PaginationMixin extends Vue {
  public currentPage = 1;
  public totalCount = 0;
  public paginationSize = 50;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public render() {}
}
